module.exports = __webpack_public_path__ + "static/media/tastemakers-campus-7.a0e672d5.png";